import { useEffect } from 'react';

/**
 * Keyboard navigation handler for chatbot Tab and Shift+Tab behavior  
 * Always excludes dimmed buttons from tab order during navigation
 */
const useKeyboardNavigation = (containerSelector = '.react-chatbot-kit-chat-container') => {

  useEffect(() => {
    const handleKeyDown = (event) => {
      // Handle both Tab and Shift+Tab - ignore all other keys
      if (event.key !== 'Tab') return;
      
      const container = document.querySelector(containerSelector);
      if (!container) return;
      
      // Always temporarily make dimmed buttons unfocusable during Tab navigation
      // This ensures they're skipped whether we're inside, entering, or exiting the chatbot
      const dimmedButtons = container.querySelectorAll('.option-inactive');
      const originalTabIndexes = [];
      
      dimmedButtons.forEach((button, index) => {
        originalTabIndexes[index] = button.getAttribute('tabindex') || '0';
        button.setAttribute('tabindex', '-1');
      });
      
      // Restore the tabindex after the navigation completes
      setTimeout(() => {
        dimmedButtons.forEach((button, index) => {
          button.setAttribute('tabindex', originalTabIndexes[index]);
        });
      }, 0);
      
      // Let the browser handle the navigation naturally with dimmed buttons excluded
    };

    document.addEventListener('keydown', handleKeyDown, true);
    
    return () => {
      document.removeEventListener('keydown', handleKeyDown, true);
    };
  }, [containerSelector]);
};

export default useKeyboardNavigation; 